<template>
  <Breadcrumb></Breadcrumb>
  <RentalListingAgreementForm :rentalListingAgreement="rentalListingAgreement" :title="$gettext('Editer une mission de location')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useRentalListingAgreementStore as useRentalListingAgreementStore } from "@/stores/rentalListingAgreement";
import { useRouter, useRoute } from "vue-router";
import RentalListingAgreementForm from "@/components/rental-listing-agreements/RentalListingAgreementForm.vue";
import { ref, onMounted } from "vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";

const router = useRouter();
const route = useRoute();
const rentalListingAgreementStore = useRentalListingAgreementStore();
const rentalListingAgreement = ref(null);
const rentalListingAgreementId = route.params.id;

const onSubmit = (payload, actions) => {
  rentalListingAgreementStore.save(payload, () => {
    router.push({ name: "rental-listing-agreement", params: { id: rentalListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

onMounted(async () => {
  rentalListingAgreement.value = await rentalListingAgreementStore.fetchOne(rentalListingAgreementId);
});

</script>
